module.exports = __webpack_public_path__ + "static/media/RI3y.69dadf00.jpg";